// ¿SUBIR ES BUENA O MALA NOTICIA?
//
// Una variación no tiene color propio: depende de QUÉ subió. Que los ingresos
// suban un 40% es una buena noticia; que los egresos suban un 40% es la misma
// flecha y la noticia opuesta. Hasta acá el color salía del signo del número,
// así que la pantalla felicitaba en verde por "Egresos +40%" y por
// "Cancelados +100%".
//
// Toda variación de la pantalla de Estadísticas pasa por acá. Si aparece una
// métrica nueva, se agrega a este mapa — no se decide el color en el componente.

/** Métricas donde SUBIR es mala noticia. El resto, subir es bueno. */
const SUBIR_ES_MALO = new Set([
  "expense",        // salidas de caja
  "canceled",       // tickets anulados
  "canceled_count",
  "cancelRate",     // tasa de anulación
  "lostIncome",     // ingreso que no se cobró
]);

export const subirEsBueno = (metrica) => !SUBIR_ES_MALO.has(metrica);

/**
 * Clase de color de una variación, según qué métrica sea.
 * @param {number} valor      la variación (puede ser negativa)
 * @param {string} metrica    clave de la métrica; si no se pasa, sube = bueno
 */
export const claseVariacion = (valor, metrica) => {
  const bueno = subirEsBueno(metrica) ? valor >= 0 : valor < 0;
  return bueno ? "text-success" : "text-danger";
};

/** La flecha sigue al NÚMERO, no a la noticia: si subió, apunta para arriba. */
export const flechaVariacion = (valor) => (valor >= 0 ? "arrow_upward" : "arrow_downward");
